module.exports = __webpack_public_path__ + "media/scholarship_winners/keisha-j-a76eb332.png";